import {Component, OnInit, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from "@angular/router";
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { ShareDataService } from '@signature-it/ngx-generic/services';

@Component({
    selector: 'main-layout',
    styleUrls: ['./main.scss'],
    templateUrl: './main.html',
    standalone: false
})
export class MainLayoutComponentGeneric implements OnInit, OnDestroy {

    fixedHeader = GenericConfig.fixedHeader;
    isRestrictedLogin: boolean = GenericConfig.restrictedLogin;
    subscriptions: Subscription;
    styleEntityVar: string = null;
    show: boolean = true;
    constructor(protected router: Router,
                public sharedSvc: ShareDataService) {
        this.subscriptions = new Subscription();
        this.sharedSvc.showBreadcrumbs$.subscribe(show => {
            setTimeout(()=> {
                this.show = show;
            });
        });
        router.events.subscribe((val) => {
            this.styleEntityVar = GenericConfig.routeBlockStyle ? (GenericConfig.routeBlockStyle.find(item => this.router.url.split('?')[0].match(item.route))?.entityVar) : null;
        });
    }

    ngOnInit(): void {
        this._getIsRestrictedLogin();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    _getIsRestrictedLogin() {
        this.subscriptions.add(this.sharedSvc.isRestrictedLogin$.subscribe(isRestricted => {
            if (isRestricted === null) return;
            this.isRestrictedLogin = isRestricted || false;
        }));
    }

}
